import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["zebra", "children", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Body.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var BaseBody = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$zebra = _ref.zebra,
      zebra = _ref$zebra === void 0 ? "even" : _ref$zebra,
      children = _ref.children,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(views.Body, _objectSpread(_objectSpread(_objectSpread({
    zebra: zebra,
    ref: ref
  }, tokens), rest), {}, {
    children: children
  }));
});
export var Body = withDesignTokens(BaseBody, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      zebraBackgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      zebraBackgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      zebraBackgroundColor: theme.palette.twilio.gray[10]
    };
  }
});